export default {
    organizationType: 'organization_type',
    ownerRealName: 'id_card_name',
    ownerIdCardNumber: 'id_card_number',
    ownerIdCardAddress: 'id_card_address',
    ownerIdCardValidTimeBegin: 'id_card_valid_time_begin',
    ownerIdCardValidTimeEnd: 'id_card_valid_time',
    ownerIdCardFrontPhoto: 'id_card_copy',
    ownerIdCardBackPhoto: 'id_card_national',
    merchantShortName: 'merchant_shortname',
    companyName: 'merchant_name',
    businessLicenseNumber: 'business_license_number',
    businessLicensePhoto: 'business_license_copy',
    contactorIdCardFrontPhoto: 'contact_id_doc_copy',
    contactorIdCardBackPhoto: 'contact_id_doc_copy_back',
    contactorIdCardValidTimeBegin: 'contact_id_doc_period_begin',
    contactorIdCardValidTimeEnd: 'contact_id_doc_period_end',
    contactorAgentLicensePhoto: 'business_authorization_letter',
    contactorType: 'contact_type',
    contactorRealName: 'contact_name',
    contactorIdCardNumber: 'contact_id_card_number',
    contactorMobilePhoneNumber: 'mobile_phone',
    contactorEmail: 'contact_email',
    bindBankAccountType: 'bank_account_type',
    openAccountName: 'account_name',
    openAccountBank: 'account_bank',
    bankAccountNumber: 'account_number',
    bankAddressCodes: 'bank_address_code',
    benefitIsSelf: 'owner',
    benefitPersonList: 'ubo_info_list',
};